<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["NO"] }}
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('U')" class="sortlogo" :class="setSortLogo('U')"></i>
                                            </template>
                                            <template v-else-if="header == 'ST'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TORPT']['ST']}}
                                            </template>
                                            <template v-else-if="header == 'ET'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TORPT']['ET']}}
                                            </template>
                                            <template v-else-if="header == 'GP'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['GP']}}
                                                <i v-if="reportType==1" @click="setSortTable('PN')" class="sortlogo" :class="setSortLogo('PN')"></i>
                                            </template>
                                            <template v-else-if="header == 'MBC'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['BETRPT']['MBC']}}
                                                <i @click="setSortTable('MBC')" class="sortlogo" :class="setSortLogo('MBC')"></i>
                                            </template>
                                            <template v-else-if="header == 'TA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TORPT']['TO']}}
                                                <i @click="setSortTable('TA')" class="sortlogo" :class="setSortLogo('TA')"></i>
                                            </template>
                                            <template v-else-if="header == 'WLA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['CKMWL']}}
                                                <i @click="setSortTable('WLA')" class="sortlogo" :class="setSortLogo('WLA')"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('TR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['TORPT']['TR']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="!hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :limitText="count => `+${count}`"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :defaultExpandLevel="Infinity"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :disable-branch-nodes="false"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            @input="selectMemberOptions"
                                            @deselect="deSelectMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchUserId" />
                            </div>
                            <!--<div class='searchCol'>
                            <span class='searchLabel'>{{this.getLanguage['TORPT']['RT']}} :</span>
                            <treeselect :multiple="false"
                                        :options="dd_reportType"
                                        :placeholder="this.utilGetDDLanguage('TORPT.RT')"
                                        v-model="reportType" />
                        </div>-->
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RSN']}} :</span>
                                <CInput size="sm"
                                        :value="searchRegisterSourceName"
                                        @change="v => searchRegisterSourceName = v"></CInput>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead>
                            <tr>
                                <th colspan="100%">{{this.getLanguage['MTA']['TOS']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_Tsl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if=" arry_Tsl.length != 0" @click="bool_showSummary = !bool_showSummary" class='kema-eft'>
                            <td style="width:25%"></td>
                            <td style="width:25%">{{this.getLanguage['MTA']['GT']}}</td>
                            <td style="width:25%" class="tableCtnRight">{{ formatNumber(decimal_gt, 2, "USD") }}</td>
                        </tr>
                        </tbody>
                        <thead v-if="bool_showSummary">
                            <tr>
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['MTA']['TMC']}}</th>
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['MTA']['TTC']}}</th>
                                <th style="width:25%" class="tableCtnRight">{{this.getLanguage['MTA']['TTA']}}</th>
                                <!--<th style="width:25%" class="tableCtnRight">{{this.getLanguage['MTA']['FTA']}}</th>-->
                            </tr>
                        </thead>
                        <tbody v-if="bool_showSummary">
                        <td colspan="100%" v-if=" arry_Tsl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_Tsl">
                            <td class="tableCtnRight">{{ formatNumber(data.TMC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.TTC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.TTA, 2, data.CS) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class='table-wrapper with_page'>
                <header class="table-header">
                    <strong>{{getLanguage['TORPT']['CTO']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                            <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                            {{this.getLanguage["BTN"]["DL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" class="sortlogo" :class="setSortLogo('U')"></i>
                                    </template>
                                    <template v-else-if="header == 'ST'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TORPT']['ST']}}
                                    </template>
                                    <template v-else-if="header == 'ET'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TORPT']['ET']}}
                                    </template>
                                    <template v-else-if="header == 'GP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['GP']}}
                                        <i v-if="reportType==1" @click="setSortTable('PN')" class="sortlogo" :class="setSortLogo('PN')"></i>
                                    </template>
                                    <template v-else-if="header == 'MBC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['MBC']}}
                                        <i @click="setSortTable('MBC')" class="sortlogo" :class="setSortLogo('MBC')"></i>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TORPT']['TO']}}
                                        <i @click="setSortTable('TA')" class="sortlogo" :class="setSortLogo('TA')"></i>
                                    </template>
                                    <template v-else-if="header == 'WLA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CKMWL']}}
                                        <i @click="setSortTable('WLA')" class="sortlogo" :class="setSortLogo('WLA')"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" class="sortlogo" :class="setSortLogo('U')"></i>
                                    </template>
                                    <template v-else-if="header == 'ST'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TORPT']['ST']}}
                                    </template>
                                    <template v-else-if="header == 'ET'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TORPT']['ET']}}
                                    </template>
                                    <template v-else-if="header == 'GP'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['GP']}}
                                        <i v-if="reportType==1" @click="setSortTable('PN')" class="sortlogo" :class="setSortLogo('PN')"></i>
                                    </template>
                                    <template v-else-if="header == 'MBC'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['BETRPT']['MBC']}}
                                        <i @click="setSortTable('MBC')" class="sortlogo" :class="setSortLogo('MBC')"></i>
                                    </template>
                                    <template v-else-if="header == 'TA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TORPT']['TO']}}
                                        <i @click="setSortTable('TA')" class="sortlogo" :class="setSortLogo('TA')"></i>
                                    </template>
                                    <template v-else-if="header == 'WLA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['CKMWL']}}
                                        <i @click="setSortTable('WLA')" class="sortlogo" :class="setSortLogo('WLA')"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_reportList==null || arr_reportList.length == 0">{{getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_reportList">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'U'">
                                    <span class="grid-line" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AGI,data.I)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.MTN)" class="tooltiptext" :style="getbgtooltip(data)" style="text-align: center;z-index: 100;font-size: 11px;position: absolute;right: 0px;top: 0px;height: 17px;">{{data.MTN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon"/>
                                            <span class="tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span class="grid-line" v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.MTN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.MTN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16" ">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'ST'">
                                    {{ formatDateTime(data.GTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}
                                </template>
                                <template v-else-if="header == 'ET'">
                                    {{ formatDateTime(data.MGTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true) }}
                                </template>
                                <template v-else-if="header == 'GP'">
                                    <span v-if="data.PN != null && data.PN != ''">{{ renderProviderName(data.PN) }}</span>
                                    <span v-else>{{ getLanguage['GL']['ALL'] }}</span>
                                </template>
                                <template v-else-if="header == 'MBC'">
                                    {{ data.MBC }}
                                </template>
                                <template v-else-if="header == 'TA'">
                                    {{ formatNumber(data.TA, 2, data.CS)  }}
                                </template>
                                <template v-else-if="header == 'WLA'">
                                    {{ formatNumber(data.WLA, 2, data.CS) }}
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <footer style=" padding: 0.57rem 0rem;" v-if="int_TP >= 2">
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                str_tableSortBy: "TA", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                // dropdown value
                ddAgentList: null,
                ddMemberList: null,
                ddDefaultMemberList: null,
                bool_showSummary: true,
                ddGameProviderList: null,
                ddGameProviderCategoryList: null,
                searchRegisterSourceName: null,
                // search fields
                searchAgi: 0,
                searchAgent: null,
                searchUserId: null,
                searchUsername: null,
                searchGameProviderId: null,
                searchCreatedTS: { startDate: this.getTodayDate(), endDate: this.getMonthEndDate() },
                arr_reportList: [],
                skipPageUpdate: false,
                dd_memberKey: 0,
                reportType: '1',
                dd_reportType: [],
                arry_Tsl: [],
                constAccessType: constAccessType,
                hideBrand: false,
                arry_vdp: [],
                searchVDP: null,
                defaultReportHeaders: ['NO', 'U', 'ST', 'ET', 'GP', 'MBC', 'TA', 'WLA'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                bool_showSearchBar: true,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            getVDP() {
                this.arry_vdp = [{ id: "", label: this.getLanguage['GL']['ALL2'] }, { id: "1", label: this.getLanguage['PM']['YES'] }, { id: "0", label: this.getLanguage['PM']['NO'] }];
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.MTBC) {
                        bgColor = data.MTBC;
                    }

                    if (data.MTC) {
                        textColor = data.MTC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            selectAgentOptions(value, instanceId) {
                //if (value) {
                //    this.setSearchCriteriaAGI(value);
                //}
                //else {
                //    this.setSearchCriteriaAGI(null);
                //}

                //this.searchAgi = 0;
                //if (value) {
                //    var agentList = value.split("-");
                //    this.searchAgi = agentList[agentList.length - 1];
                //}
                var temp = "";
                for (var x = 0; x < value.length; x++) {
                    if (x != 0) {
                        temp += ",";
                    }
                    var split = value[x].split("-");

                    if (split.length == 2) {
                        temp += split[1];
                    }
                    else {
                        temp += split[0];
                    }
                }
                this.searchAgi = temp;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            getReportList() {
                this.bool_fullLoading = true;
                var that = this;
                //var agentGId = null;

                //if (this.searchAgi > 0) {
                //    agentGId = this.searchAgi;
                //}

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}
                if (this.searchAgi) {
                    path += "&f.AGI_csv=" + this.searchAgi;
                }
                if (this.searchUserId) {
                    path += "&f.MI=" + this.searchUserId;
                }

                if (this.searchGameProviderId && this.searchGameProviderId.length > 0) {
                    for (var i = 0; i < this.searchGameProviderId.length; i++) {
                        path += "&f.ProviderIDs=" + this.searchGameProviderId[i];
                    }
                }

                if (this.searchCreatedTS.startDate != "" && this.searchCreatedTS.endDate != "") {
                    path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                }

                if (this.reportType) {
                    path += "&f.RT=" + this.reportType;
                }

                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (this.searchRegisterSourceName) {
                    path += "&f.RSN=" + this.searchRegisterSourceName;
                }

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.getDataApi(`/api/reports/turnover2?${path}`,
                    function (d) {
                        that.bool_fullLoading = false;
                        that.int_TP = Math.max(d.D.TotalPages, 1);
                        that.int_Total = d.D.TotalItems;
                        that.arr_reportList = d.D.Items;
                        that.resizeTableHead();
                    });

                this.getDataApi(`/api/reports/lr/total?${path}`,
                    function (data) {
                        that.setTurnoverSummaryList(data);
                    });
            },
            saveToExcel() {
                if (this.reportType != null) {

                    //var agentGId = null;

                    //if (this.searchAgi > 0) {
                    //    agentGId = this.searchAgi;
                    //}

                    var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                    var hasDefaultPath = false;

                    if (path) {
                        hasDefaultPath = true;
                    }

                    //if (agentGId) {
                    //    path += "&f.AGI=" + agentGId;
                    //}

                    if (this.searchAgi) {
                        path += "&f.AGI_csv=" + this.searchAgi;
                    }

                    if (this.searchUserId) {
                        path += "&f.MI=" + this.searchUserId;
                    }

                    if (this.searchGameProviderId && this.searchGameProviderId.length > 0) {
                        for (var i = 0; i < this.searchGameProviderId.length; i++) {
                            path += "&f.ProviderIDs=" + this.searchGameProviderId[i];
                        }
                    }


                    if (this.searchCreatedTS.startDate != "" && this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }



                    if (this.reportType) {
                        path += "&f.RT=" + this.reportType;
                    }
                    if (this.searchVDP) {
                        path += "&f.VDP=" + this.searchVDP;
                    }
                    if (this.searchRegisterSourceName) {
                        path += "&f.RSN=" + this.searchRegisterSourceName;
                    }
                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }

                    window.open('/api/reports/turnoverexcel/summary?' + path, '_blank');
                } else {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["TORPT"]["RT"]), 1000);
                }
                /*
                else {
                    this.showErrorMessage(null, this.getLanguage['WLRPT']['PSP'], 1000);
                }
                */
            },
            setTurnoverSummaryList(data) {
                this.arry_Tsl = data;
                this.decimal_gt = 0;
                if (this.arry_Tsl.length != 0) {
                    for (var i = 0; i < this.arry_Tsl.length; i++) {
                        this.decimal_gt += this.arry_Tsl[i].GT;
                    }
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            selectMemberOptions(node, instanceId) {
                // this.searchAgi = node.agi;
            },
            deSelectMemberOptions(node, instanceId) {
                this.searchUserId = null;
                this.searchUsername = null;
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            selectGameProvider(value, instanceId) {

            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                d.dropdownlist[j].label = that.renderCategory(d.dropdownlist[j].id.slice(d.dropdownlist[j].id.indexOf('-') + 1));
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getTodayDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderClassName(header, data) {
                if (header == 'WLA' && data && data.WLA >= 0) {
                    return "tableCtnRight positive-number ";
                } else if (header == 'WLA' && data && data.WLA < 0) {
                    return "tableCtnRight negative-number ";
                } else if (header == 'U') {
                    return "kema-eft";
                } else if (header == 'MBC' || header == 'TA' || header == 'WLA') {
                    return "tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            // EndTimeFormat(val, val2) {
            //     var PickendDate = this.searchCreatedTS.endDate;
            //     var result = val.toString();
            //     var month = new Array();
            //     month[0] = "Jan";
            //     month[1] = "Feb";
            //     month[2] = "Mar";
            //     month[3] = "Apr";
            //     month[4] = "May";
            //     month[5] = "June";
            //     month[6] = "Jul";
            //     month[7] = "Aug";
            //     month[8] = "Sept";
            //     month[9] = "Oct";
            //     month[10] = "Nov";
            //     month[11] = "Dec";
            //     if (result == "01/01/0001 00:00") {
            //         var today = new Date();
            //         var endDate = new Date(PickendDate);
            //         var dateOne = new Date(endDate.getFullYear(), endDate.getMonth() + 1, endDate.getDate()); //Year, Month, Date
            //         var dateTwo = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate()); //Year, Month, Date
            //         if (dateOne < dateTwo) {
            //             var date = endDate.getDate() + " " + (month[endDate.getMonth()]) + " " + endDate.getFullYear();
            //             result = date + " " + "23:59:59";
            //         }
            //         else {
            //             var date = endDate.getDate() + " " + (month[endDate.getMonth()]) + " " + endDate.getFullYear();
            //             var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            //             result = date + " " + time;
            //         }

            //     }
            //     return result;
            // }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS2';
            this.$parent.showActiveMenu = 'R.TR';

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.searchUserId = this.$route.query.i;
            this.searchUsername = this.$route.query.u;
            this.searchAgi = this.$route.query.agi;
            this.dd_reportType = [{ id: '1', label: this.getLanguage['TORPT']['BP'] }];

            if (this.searchAgi) {
                this.searchAgent = '3-' + this.searchAgi;
            }
            if (this.searchUserId && this.searchUsername) {
                this.ddDefaultMemberList = [
                    { id: this.searchUserId, label: this.searchUsername }
                ];
            }
            this.getVDP();
        },
        watch: {
            getLanguage() {
                this.getVDP();
                this.getReportList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/TurnoverReport`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                    
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/TurnoverReport/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>

<style>
    .game {
        border-spacing: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/TurnoverReport.vue